import {
  utils,
} from '@ama-sdk/core';
import {
  MockAlternativeOffer,
  todayPlusNdays,
} from '@dapi/sdk/spec';

export const getAlternativeOffersDisruptedOneWay =
{
  'data': [
    {
      'type': 'alternative-offers',
      'id': '2VFhfc59v4W9K3W',
      'expiryDateTime': '2023-09-05T11:08:22Z',
      'air': {
        'bound': {
          'originLocationCode': 'ORY',
          'destinationLocationCode': 'CUN',
          'duration': 40500,
          'flights': [
            {
              'id': 'FLT1',
              'bookingClass': 'E',
              'cabin': 'eco'
            }
          ]
        }
      }
    },
    {
      'type': 'alternative-offers',
      'id': '2VFhfc79v4W5Miv',
      'expiryDateTime': '2023-09-05T11:08:22Z',
      'air': {
        'bound': {
          'originLocationCode': 'ORY',
          'destinationLocationCode': 'CUN',
          'duration': 40500,
          'flights': [
            {
              'id': 'FLT2',
              'bookingClass': 'E',
              'cabin': 'eco'
            }
          ]
        }
      }
    }
  ],
  'dictionaries': {
    'airline': {
      'TX': 'AIR CARAIBES'
    },
    'location': {
      'CUN': {
        'type': 'airport',
        'airportName': 'INTERNATIONAL',
        'cityCode': 'CUN',
        'cityName': 'CANCUN',
        'countryCode': 'MX'
      },
      'ORY': {
        'type': 'airport',
        'airportName': 'ORLY',
        'cityCode': 'PAR',
        'countryCode': 'FR'
      },
      'PAR': {
        'type': 'city',
        'cityCode': 'PAR',
        'cityName': 'PARIS',
        'countryCode': 'FR'
      }
    },
    'flight': {
      'FLT2': {
        'departure': {
          'locationCode': 'ORY',
          'dateTime': '2023-11-08T12:50:00+01:00',
          'terminal': '4'
        },
        'arrival': {
          'locationCode': 'CUN',
          'dateTime': '2023-11-08T18:05:00-05:00',
          'terminal': '3'
        },
        'marketingAirlineCode': 'TX',
        'operatingAirlineCode': 'TX',
        'marketingFlightNumber': '648',
        'duration': 40500,
        'aircraftCode': '359'
      },
      'FLT1': {
        'departure': {
          'locationCode': 'ORY',
          'dateTime': '2023-11-11T12:50:00+01:00',
          'terminal': '4'
        },
        'arrival': {
          'locationCode': 'CUN',
          'dateTime': '2023-11-11T18:05:00-05:00',
          'terminal': '3'
        },
        'marketingAirlineCode': 'TX',
        'operatingAirlineCode': 'TX',
        'marketingFlightNumber': '648',
        'duration': 40500,
        'aircraftCode': '359'
      }
    },
    'aircraft': {
      '359': 'AIRBUS A350-900'
    }
  }
}

export const alternativeOfferDisruptedOutBound : MockAlternativeOffer =
    {
      type: 'alternative-offers',
      id: '2QTNfF6WeJs8N7I',
      air: {
        bound: {
          originLocationCode: 'ORY',
          destinationLocationCode: 'CUN',
          originLocation: {
            cityCode: 'PAR',
            type: 'airport',
            cityName: 'PARIS'
          },
          destinationLocation: {
            cityCode: 'CUN',
            type: 'airport',
            cityName: 'CANCUN'
          },
          duration: 3300,
          flights: [
            {
              id: 'FLT1',
              flight: {
                departure: {
                  locationCode: 'ORY',
                  dateTime: new utils.DateTime(todayPlusNdays('10:49', 5))
                },
                arrival: {
                  locationCode: 'CUN',
                  dateTime: new utils.DateTime(todayPlusNdays('15:49', 5))
                },
                marketingAirlineCode: 'TX',
                operatingAirlineCode: 'TX',
                marketingFlightNumber: '362',
                marketingAirline: 'TX',
                duration: 3300,
                aircraftCode: '32N'
              }
            }
          ]
        }
      }
    };
    
export const getAlternativeOffersMockDisruptedOutbound = {
  data: [
    {
      ...alternativeOfferDisruptedOutBound
    }
  ]
};

export const alternativeOfferIntDisruptedOutBound : MockAlternativeOffer =
    {
      type: 'alternative-offers',
      id: '2VFhfC80yIPTV2D',
      air: {
        bound: {
          originLocationCode: 'ORY',
          destinationLocationCode: 'CUN',
          originLocation: {
            cityCode: 'ATH',
            type: 'airport',
            cityName: 'ATHENS'
          },
          destinationLocation: {
            cityCode: 'LHR',
            type: 'airport',
            cityName: '"LONDON'
          },
          duration: 39900,
          flights: [
            {
              id: 'FLT1',
              flight: {
                departure: {
                  locationCode: 'ORY',
                  dateTime: new utils.DateTime(todayPlusNdays('10:49', 5))
                },
                arrival: {
                  locationCode: 'CUN',
                  dateTime: new utils.DateTime(todayPlusNdays('15:49', 5))
                },
                marketingAirlineCode: 'TX',
                operatingAirlineCode: 'TX',
                marketingFlightNumber: '648',
                marketingAirline: 'A3',
                duration: 39900,
                aircraftCode: '332'
              }
            }
          ]
        }
      }
    };
    export const alternativeOfferDisruptedOutBoundMock : MockAlternativeOffer =
    {
      type: 'alternative-offers',
      id: '2VFhfMm4ydxTB4V',
      air: {
        bound: {
          originLocationCode: 'PTP',
          destinationLocationCode: 'FDF',
          originLocation: {
            cityCode: 'PTP',
            type: 'airport',
            cityName: 'Manila'
          },
          destinationLocation: {
            cityCode: 'FDF',
            type: 'airport',
            cityName: 'Cebu'
          },
          duration: 2700,
          flights: [
            {
              id: 'FLT1',
              flight: {
                departure: {
                  locationCode: 'PTP',
                  dateTime: new utils.DateTime(todayPlusNdays('10:49', 5))
                },
                arrival: {
                  locationCode: 'FDF',
                  dateTime: new utils.DateTime(todayPlusNdays('15:49', 5))
                },
                marketingAirlineCode: 'TX',
                operatingAirlineCode: 'TX',
                marketingFlightNumber: '120',
                marketingAirline: 'PR',
                duration: 3300,
                aircraftCode: 'AT6'
              }
            }
          ]
        }
      }
    };
export const alternativeOfferDisruptedInBoundMock : MockAlternativeOffer =
    {
      type: 'alternative-offers',
      id: '2QTNfF6WeJs8N7I',
      air: {
        bound: {
          originLocationCode: 'CEB',
          destinationLocationCode: 'MNL',
          destinationLocation: {
            cityCode: 'MNL',
            type: 'airport',
            cityName: 'Manila'
          },
          originLocation: {
            cityCode: 'CEB',
            type: 'airport',
            cityName: 'Cebu'
          },
          duration: 3300,
          flights: [
            {
              id: 'FLT1',
              flight: {
                departure: {
                  locationCode: 'CEB',
                  dateTime: new utils.DateTime(todayPlusNdays('10:49', 5))
                },
                arrival: {
                  locationCode: 'MNL',
                  dateTime: new utils.DateTime(todayPlusNdays('15:49', 5))
                },
                marketingAirlineCode: 'PR',
                operatingAirlineCode: 'PR',
                marketingFlightNumber: '120',
                marketingAirline: 'PR',
                duration: 3300,
                aircraftCode: '32N'
              }
            }
          ]
        }
      }
    };

    export const getAlternativeOffersIntMockDisruptedOutbound = {
      data: [
        {
          ...alternativeOfferIntDisruptedOutBound
        },
        {
          ...alternativeOfferIntDisruptedOutBound,
          id: '2VFhfC80yIPTV2D',
          air: {
            bound: {
              ...alternativeOfferIntDisruptedOutBound.air.bound,
              flights: [
                {
                  id: 'FLT1',
                  flight: {
                    departure: {
                      locationCode: 'ATH',
                      dateTime: new utils.DateTime(todayPlusNdays('10:49', 6))
                    },
                    arrival: {
                      locationCode: 'LHR',
                      dateTime: new utils.DateTime(todayPlusNdays('15:49', 6))
                    },
                    marketingAirlineCode: 'A3',
                    operatingAirlineCode: 'A3',
                    marketingFlightNumber: '602',
                    marketingAirline: 'A3',
                    duration: 14400,
                    aircraftCode: '32Q'
                  }
                }
              ]
            }
          }
        }
      ]
    };

    export const getAlternativeOffersMockDisruptedInboundDomFixedDate = {
      data: [
        {
          ...alternativeOfferDisruptedInBoundMock,
          id: '2QTNfF8WeJs9yL4',
          air: {
            bound: {
              originLocationCode: 'FDF',
              destinationLocationCode: 'PTP',
              originLocation: {
                cityCode: 'FDF',
                type: 'airport',
                cityName: 'Manila'
              },
              destinationLocation: {
                cityCode: 'PTP',
                type: 'airport',
                cityName: 'Hong Kong'
              },
              duration: 2700,
              flights: [
                {
                  id: 'FLT2',
                  flight: {
                    departure: {
                      locationCode: 'FDF',
                      dateTime: new utils.DateTime('2025-01-20T13:14:38.179')
                    },
                    arrival: {
                      locationCode: 'PTP',
                      dateTime: new utils.DateTime('2025-01-20T15:14:38.179')
                    },
                    marketingAirlineCode: 'TX',
                    operatingAirlineCode: 'TX',
                    marketingFlightNumber: '400',
                    marketingAirline: 'TX',
                    duration: 3300,
                    aircraftCode: 'AT6'
                  }
                }
              ]
            }
          }
        }
      ]
    };
    


    export const getAlternativeOffersMockDisruptedOutboundDomFixedDate = {
      data: [
        {
          ...alternativeOfferDisruptedOutBoundMock,
          id: '2VFhfMm4ydxTB4V',
          air: {
            bound: {
              originLocationCode: 'PTP',
              destinationLocationCode: 'FDF',
              originLocation: {
                cityCode: 'PTP',
                type: 'airport',
                cityName: 'Manila'
              },
              destinationLocation: {
                cityCode: 'FDF',
                type: 'airport',
                cityName: 'Hong Kong'
              },
              duration: 2700,
              flights: [
                {
                  id: 'FLT1',
                  flight: {
                    departure: {
                      locationCode: 'PTP',
                      dateTime: new utils.DateTime('2025-01-20T13:14:38.179')
                    },
                    arrival: {
                      locationCode: 'FDF',
                      dateTime: new utils.DateTime('2025-01-20T15:14:38.179')
                    },
                    marketingAirlineCode: 'TX',
                    operatingAirlineCode: 'TX',
                    marketingFlightNumber: '401',
                    marketingAirline: 'TX',
                    duration: 2700,
                    aircraftCode: 'AT6'
                  }
                }
              ]
            }
          }
        }
      ]
    };

export const createAsynchronousJobForAlternativeOfferConfirmationError = {
  errors: [{code: '65211', title: 'FUNCTIONALITY NOT ENABLED'}]
};

export const createAsynchronousJobForAlternativeOfferConfirmationSuccess = {
  data: {
    id: 'AY12138213',
    status: 'inProgress'
  }
};

export const getAlternativeOfferConfirmationJobPending = {
  data: {
    id: 'AY12138213',
    status: 'completed'
  }
};

export const getAlternativeOfferConfirmationJobCompleted = {
  data: {
    id: 'AY12138213',
    status: 'completed',
    reacceptanceStatus: 'completed'
  }
};

export const getAlternativeOfferConfirmationJobError = {
  errors: [{code: '65019', title: 'UNABLE TO PROCESS'}]
};

export const createAlternativeOfferConfirmationJobPendingCheckin = {
  data: {
    id: 'AF57516314',
    status: 'inProgress'
  }
};

export const getAlternativeOfferConfirmationJobPendingCheckinStarted = {
  data: {
    id: 'AF57516314',
    status: 'inProgress',
    reacceptanceStatus: 'inProgress'
  }
};
